// Module
var code = `<!--
<h1 class="font-lusitana mb-8 text-xl md:text-2xl">{{heading}}</h1>
-->
<div data-slot="search"></div>
<div class="mt-6 flow-root">
  <div class="overflow-x-auto">
    <div class="inline-block min-w-full align-middle">
      <div class="overflow-hidden rounded-md bg-gray-50 p-2 md:pt-0">
        <!-- Below md the same customers render as a card stack. The source
             renders both and hides one per breakpoint, so both are kept. -->
        <div class="md:hidden">
          {{#customers}}
          <div
            class="mb-2 w-full rounded-md bg-white p-4"
            data-customer-id="{{attrCustomerId}}"
          >
            <div class="flex items-center justify-between border-b pb-4">
              <div>
                <div class="mb-2 flex items-center">
                  <div class="flex items-center gap-3">
                    <img
                      src="{{attrImageSrc}}"
                      class="rounded-full"
                      alt="{{attrImageAlt}}"
                      width="28"
                      height="28"
                    />
                    <p>{{name}}</p>
                  </div>
                </div>
                <p class="text-sm text-gray-500">{{email}}</p>
              </div>
            </div>
            <div class="flex w-full items-center justify-between border-b py-5">
              <div class="flex w-1/2 flex-col">
                <p class="text-xs">Pending</p>
                <p class="font-medium">{{totalPending}}</p>
              </div>
              <div class="flex w-1/2 flex-col">
                <p class="text-xs">Paid</p>
                <p class="font-medium">{{totalPaid}}</p>
              </div>
            </div>
            <div class="pt-4 text-sm">
              <p>{{totalInvoices}} invoices</p>
            </div>
          </div>
          {{/customers}}
        </div>

        <table class="hidden min-w-full rounded-md text-gray-900 md:table">
          <thead class="rounded-md bg-gray-50 text-left text-sm font-normal">
            <tr>
              <th scope="col" class="px-4 py-5 font-medium sm:pl-6">Name</th>
              <th scope="col" class="px-3 py-5 font-medium">Email</th>
              <th scope="col" class="px-3 py-5 font-medium">Total Invoices</th>
              <th scope="col" class="px-3 py-5 font-medium">Total Pending</th>
              <th scope="col" class="px-4 py-5 font-medium">Total Paid</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 text-gray-900">
            {{#customers}}
            <tr class="group" data-customer-id="{{attrCustomerId}}">
              <td
                class="whitespace-nowrap bg-white py-5 pl-4 pr-3 text-sm text-black group-first-of-type:rounded-md group-last-of-type:rounded-md sm:pl-6"
              >
                <div class="flex items-center gap-3">
                  <img
                    src="{{attrImageSrc}}"
                    class="rounded-full"
                    alt="{{attrImageAlt}}"
                    width="28"
                    height="28"
                  />
                  <p>{{name}}</p>
                </div>
              </td>
              <td class="whitespace-nowrap bg-white px-4 py-5 text-sm">
                {{email}}
              </td>
              <td class="whitespace-nowrap bg-white px-4 py-5 text-sm">
                {{totalInvoices}}
              </td>
              <td class="whitespace-nowrap bg-white px-4 py-5 text-sm">
                {{totalPending}}
              </td>
              <td
                class="whitespace-nowrap bg-white px-4 py-5 text-sm group-first-of-type:rounded-md group-last-of-type:rounded-md"
              >
                {{totalPaid}}
              </td>
            </tr>
            {{/customers}}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
`;
// Exports
module.exports = code;